import React from 'react';
import { Typography } from '@mui/material';
import CheckMarkIcon from 'crono-fe-common/icons/Icon-CheckMark';
import CloseSIcon from 'crono-fe-common/icons/Icon-Close-S';
import { colors } from 'crono-fe-common/theme';
import styled from '@emotion/styled';

interface IProps {
  style?: React.CSSProperties;
}

const IfInvitationIsAcceptedBanner = ({ style }: IProps) => {
  return (
    <BannersWrapper className="if-invitation-is-accepted-banner" style={style}>
      <div className="icon-wrapper-step-banners">
        <CheckMarkIcon className="icon" color={colors.primaryDark} />
      </div>
      <Typography
        fontSize={12}
        lineHeight={'16px'}
        fontWeight={500}
        color={colors.primaryDark}
      >
        If invitation is accepted
      </Typography>
    </BannersWrapper>
  );
};

const IfInvitationIsNotAcceptedBanner = ({ style }: IProps) => {
  return (
    <BannersWrapper
      className="if-invitation-is-not-accepted-banner"
      style={style}
    >
      <div className="icon-wrapper-step-banners">
        <CloseSIcon className="icon" color={colors.inactiveHover} />
      </div>
      <Typography
        fontSize={12}
        lineHeight={'16px'}
        fontWeight={500}
        color={colors.inactiveHover}
      >
        If invitation is not accepted
      </Typography>
    </BannersWrapper>
  );
};

export const BannersWrapper = styled.div`
  &.if-invitation-is-not-accepted-banner,
  &.if-invitation-is-accepted-banner {
    padding: 4px 8px;
    margin: -10px -16px 12px -16px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    border-bottom: 1px solid ${colors.grey33};
    .icon-wrapper-step-banners {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      .icon {
        width: 12px;
        height: 12px;
      }
    }
  }
  &.if-invitation-is-accepted-banner {
    background: ${colors.primaryLight};
    .icon-wrapper-step-banners {
      background: ${colors.primaryLightHover};
    }
  }
  &.if-invitation-is-not-accepted-banner {
    background: ${colors.inactiveLight};
    .icon-wrapper-step-banners {
      background: ${colors.inactiveLightHover};
    }
  }
`;

export { IfInvitationIsAcceptedBanner, IfInvitationIsNotAcceptedBanner };
